import { useReCaptchaContext } from "@/components/providers/ReCaptchaProvider";

// ----------------------------------------------------------------------------
// Thin wrapper kept for API compatibility with the 9 form components that
// already destructure { reCaptchaRef, isReCaptchaAvailable, isRecaptchaVarified,
// resetReCaptcha } from this hook. Delegates to the singleton ReCaptchaProvider
// at the root so reCAPTCHA's 373 KB script loads exactly once per page.
// ----------------------------------------------------------------------------

const useGoogleReCaptcha = () => useReCaptchaContext();

export default useGoogleReCaptcha;
